/**
 * Утилиты для страницы деталей баттла
 */

/**
 * Форматирование даты
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return 'Не указано';
  const date = new Date(dateStr);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Проверка: может ли пользователь управлять участниками
 */
export const canManageParticipants = (user, isOrganizer) => {
  return isOrganizer;
};

/**
 * Проверка: открыта ли регистрация
 */
export const isRegistrationOpen = (status) => {
  return status === 'PLANNED' || status === 'ACTIVE';
};

/**
 * Проверка: является ли пользователь организатором
 */
export const checkIsUserOrganizer = (currentUser, battle, participants) => {
  if (!currentUser) return false;

  const userProfileId =
    currentUser.publicProfile?.id ||
    (Array.isArray(currentUser.profiles) && currentUser.profiles[0]?.id) ||
    null;

  // Проверка через battle.organizers
  if (battle?.organizers && Array.isArray(battle.organizers)) {
    const fromOrganizers = battle.organizers.some((o) => {
      if (o.userId && o.userId === currentUser.id) return true;
      if (o.publicProfileId && o.publicProfileId === currentUser.id) return true;
      if (o.publicProfileId && userProfileId && o.publicProfileId === userProfileId) return true;
      if (o.nickname && currentUser.nickname && o.nickname === currentUser.nickname) return true;
      if (o.name && currentUser.name && o.name === currentUser.name) return true;
      return false;
    });
    if (fromOrganizers) return true;
  }

  // Fallback: проверка через participants
  if (participants && participants.length > 0) {
    const fromParticipants = participants.some((p) => {
      if (p.role !== 'ORGANIZER') return false;
      if (p.userId && p.userId === currentUser.id) return true;
      if (p.publicProfileId && p.publicProfileId === currentUser.id) return true;
      if (p.publicProfileId && userProfileId && p.publicProfileId === userProfileId) return true;
      if (p.nickname && currentUser.nickname && p.nickname === currentUser.nickname) return true;
      if (p.name && currentUser.name && p.name === currentUser.name) return true;
      return false;
    });
    if (fromParticipants) return true;
  }

  return false;
};

/**
 * Проверка: зарегистрирован ли пользователь
 */
export const checkIsRegistered = (currentUser, participants) => {
  if (!currentUser || !participants?.length) return false;

  return participants.some(
    (p) => p.userId === currentUser.id || p.publicProfileId === currentUser.id
  );
};
